import { useTranslation } from 'react-i18next';

import { AlertDialog, Button, Tooltip } from '~/components';

import { tableSectionStyle } from '../FormLines.css';
import { DeletePhotoAlbumSectionDialog } from './DeletePhotoAlbumSectionDialog';
import { actionStyle, descriptionStyle, nameStyle, sectionTitleStyle, tagStyle, titleStyle } from './SectionTitle.css';

export const PhotoAlbumSectionTitle = () => {
  const { t } = useTranslation(['common', 'lines']);

  return (
    <tbody className={tableSectionStyle}>
      <tr className={sectionTitleStyle}>
        <td className={titleStyle} colSpan={5}>
          <p>
            <span className={nameStyle}>{t('lines:photoAlbum.title')}</span>

            <Tooltip content={t('lines:photoAlbum.tagTooltip')}>
              <span className={tagStyle}>{t('lines:photoAlbum.tag')}</span>
            </Tooltip>
          </p>

          <p>
            <small className={descriptionStyle}>{t('lines:photoAlbum.description')}</small>
          </p>
        </td>

        <td className={actionStyle}>
          <AlertDialog.Root>
            <AlertDialog.Trigger render={<Button aria-label={t('common:actions.delete')} icon="Trash" />} />
            <DeletePhotoAlbumSectionDialog />
          </AlertDialog.Root>
        </td>
      </tr>
    </tbody>
  );
};
